import html2pdf from "html2pdf.js";
import moment from "moment";

export const handleDayGlancePdf = (
  filteredData = [],
  saleReturnData = [],
  purchaseData = [],
  purchaseReturnData = [],
  supplierData = [],
  receiptData = [],
  bankData = [],
  journalReceiptData = [],
  journalPaymentData = [],
) => {
  const currentDate = new Date().toLocaleDateString();

  /* ---------------- HTML START ---------------- */
  let htmlContent = `
  <html>
    <head>
      <title>Day Glance Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 20px;
        }
        .header {
          text-align: center;
          margin-bottom: 20px;
        }
        .header h1 {
          margin: 0;
          font-size: 18px;
        }
        .header .date {
          font-size: 12px;
          margin-top: 5px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 20px;
        }
        th, td {
          border: 1px solid #3b3b3b;
          padding: 3px;
          font-size: 10px;
          text-align: right;
        }
        th {
          background: #d4d2d2ff;
          font-weight: bold;
        }
        th:first-child,
        td:first-child {
          text-align: left;
        }
        .group-header {
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin: 15px 0 8px;
        }
        .totals-row {
          background: #dfefff;
          font-weight: bold;
        }
        .desc {
          text-align: center;
          font-weight: normal;
        }
        @media print {
          .group-header {
            page-break-before: auto;
          }
        }
          * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>Day Glance Report</h1>
        <div class="date">Date: ${currentDate}</div>
      </div>
  `;
  /* ---------------- HTML END ---------------- */

  /* ----------- TABLE RENDER FUNCTION ----------- */
  const renderTable = (title, data) => {
    if (!Array.isArray(data) || data.length === 0) return "";
    let totals = {
      QTY: 0,
      TOTAMT: 0,
      DISCOUNT: 0,
      NETAMT: 0,
      CASH: 0,
      CARD: 0,
      UPI: 0,
      ONLINE: 0,
      BALANCE: 0,
      CHEQUE: 0,
    };

    let rows = "";

    data.forEach((item) => {
      rows += `
        <tr>
          <td>${item.billno || ""}</td>
          <td>${item.totqty || 0}</td>
          <td>${item.totamt || 0}</td>
          <td>${item.discount || 0}</td>
          <td>${item.NETAMT || 0}</td>
          <td>${item.PAIDCASH || 0}</td>
          <td>${item.PAIDCARD || 0}</td>
          <td>${item.PAIDUPI || 0}</td>
          <td>${item.PAIDONLINE || 0}</td>
          <td>${item.BALANCE || 0}</td>
          <td>${item.PAIDCHEQUE || 0}</td>
        </tr>
        <tr>
          <td>${moment(item.BillDate).format("DD/MM/YYYY")}</td>
          <td colspan="4" class="desc">${item.CustName || ""}</td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
        </tr>
      `;

      totals.QTY += Number(item.totqty || 0);
      totals.TOTAMT += Number(item.totamt || 0);
      totals.DISCOUNT += Number(item.discount || 0);
      totals.NETAMT += Number(item.NETAMT || 0);
      totals.CASH += Number(item.PAIDCASH || 0);
      totals.CARD += Number(item.PAIDCARD || 0);
      totals.UPI += Number(item.PAIDUPI || 0);
      totals.ONLINE += Number(item.PAIDONLINE || 0);
      totals.BALANCE += Number(item.BALANCE || 0);
      totals.CHEQUE += Number(item.PAIDCHEQUE || 0);
    });

    return `
      <div class="group-header">${title}</div>
      <table>
        <thead>
          <tr>
            <th>INVNO</th>
            <th>QTY</th>
            <th>TOT AMT</th>
            <th>DISCOUNT</th>
            <th>NET AMT</th>
            <th>CASH</th>
            <th>CARD</th>
            <th>UPI</th>
            <th>ONLINE</th>
            <th>BALANCE</th>
            <th>CHEQUE</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
          <tr class="totals-row">
            <td>Total</td>
            <td>${totals.QTY}</td>
            <td>${totals.TOTAMT.toFixed(2)}</td>
            <td>${totals.DISCOUNT.toFixed(2)}</td>
            <td>${totals.NETAMT.toFixed(2)}</td>
            <td>${totals.CASH.toFixed(2)}</td>
            <td>${totals.CARD.toFixed(2)}</td>
            <td>${totals.UPI.toFixed(2)}</td>
            <td>${totals.ONLINE.toFixed(2)}</td>
            <td>${totals.BALANCE.toFixed(2)}</td>
            <td>${totals.CHEQUE.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    `;
  };

  /* ----------- APPEND ALL SECTIONS ----------- */
  htmlContent += renderTable("SALE", filteredData);
  htmlContent += renderTable("SALE RETURN", saleReturnData);
  htmlContent += renderTable("PURCHASE", purchaseData);
  htmlContent += renderTable("PURCHASE RETURN", purchaseReturnData);
  htmlContent += renderTable("SUPPLIER PAYMENT", supplierData);
  htmlContent += renderTable("RECEIPT", receiptData);
  htmlContent += renderTable("BANK ENTRYS", bankData);
  htmlContent += renderTable("JOURNAL RECEIPT", journalReceiptData);
  htmlContent += renderTable("JOURNAL PAYMENT", journalPaymentData);

  htmlContent += `
    </body>
  </html>
  `;

  /* ----------- IFRAME PRINT ----------- */
  //   const iframe = document.createElement("iframe");
  //   iframe.style.position = "fixed";
  //   iframe.style.right = "0";
  //   iframe.style.bottom = "0";
  //   iframe.style.width = "0";
  //   iframe.style.height = "0";
  //   iframe.style.border = "0";
  //   document.body.appendChild(iframe);

  //   iframe.contentWindow.document.open();
  //   iframe.contentWindow.document.write(htmlContent);
  //   iframe.contentWindow.document.close();

  //   iframe.onload = () => {
  //     iframe.contentWindow.focus();
  //     iframe.contentWindow.print();
  //     setTimeout(() => iframe.remove(), 1500);
  //   };
  const opt = {
    margin: [0, 10, 0, 10],
    filename: `day_glance_report.pdf`,
    image: { type: "jpeg", quality: 1 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  };

  // start download
  html2pdf().from(htmlContent).set(opt).save();
};
